module.exports = __webpack_public_path__ + "static/blog-hero.597073e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/blog-hero.svg
// module id = 457
// module chunks = 212839066777427